export default __webpack_public_path__ + "static/kb_3_11-b258b17dbb8354a7d5de6e3796830e82.jpg";